// export const SERVER_URL = "https://p2papi.pleximus.co.in/api/v4";
//export const SERVER_URL = "https://173.212.236.21:4044/api";
//export const SERVER_URL = "http://3.143.37.165:4044/api";
// export const SERVER_URL = "http://3.111.78.199:4044/api";
// export const SERVER_URL = "http://13.233.81.253:4044/api/v4";
// export const SERVER_URL = "https://adminapi.p2pcarz.com/api/v3";
 export const SERVER_URL = "https://adminapi.p2pcarz.com:8443/api/v4";
